export default "__VITE_ASSET__CBnbpiu0__"